module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.38a616e2.png";